/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FunnelCustomFieldDefinitionsAddBodyParams } from '../models/FunnelCustomFieldDefinitionsAddBodyParams';
import type { FunnelCustomFieldDefinitionsGetResponse } from '../models/FunnelCustomFieldDefinitionsGetResponse';
import type { FunnelCustomFieldDefinitionsUpdateBodyParams } from '../models/FunnelCustomFieldDefinitionsUpdateBodyParams';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CrmFunnelsCustomFieldDefinitionsService {
    /**
     * Get custom field definitions for a funnel
     * @param funnelId
     * @returns FunnelCustomFieldDefinitionsGetResponse Ok
     * @throws ApiError
     */
    public static getFunnelCustomFieldDefinitions(
        funnelId: number,
    ): CancelablePromise<FunnelCustomFieldDefinitionsGetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/crm/funnels/{funnelId}/custom-field-definitions',
            path: {
                'funnelId': funnelId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * Replace all custom field definitions for a funnel
     * @param funnelId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updateFunnelCustomFieldDefinitions(
        funnelId: number,
        requestBody: FunnelCustomFieldDefinitionsUpdateBodyParams,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/crm/funnels/{funnelId}/custom-field-definitions',
            path: {
                'funnelId': funnelId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * Add custom field definitions to a funnel
     * @param funnelId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static addFunnelCustomFieldDefinitions(
        funnelId: number,
        requestBody: FunnelCustomFieldDefinitionsAddBodyParams,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/crm/funnels/{funnelId}/custom-field-definitions',
            path: {
                'funnelId': funnelId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * Reorder funnel custom field definitions (top-to-bottom order)
     * @param funnelId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static reorderFunnelCustomFieldDefinitions(
        funnelId: number,
        requestBody: FunnelCustomFieldDefinitionsUpdateBodyParams,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/crm/funnels/{funnelId}/custom-field-definitions/order',
            path: {
                'funnelId': funnelId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
}
